import React from "react";
import {
  FaPhoneAlt,
  FaYoutube,
  FaInstagram,
  FaLinkedinIn,
  FaFacebook,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { AiFillTwitterCircle } from "react-icons/ai";

const Footer = () => {
  return (
    <div
      id="footer"
      style={{
        background:
          " url('/assests/footerPic.png') no-repeat center center/cover",
      }}
    >
      <div className="footer py-5">
        <div className="d-flex justify-content-center footerDirection fs-5">
          <Link style={{ textDecoration: "none" }} to="/">
            <p style={{ color: "#FFF" }} className="px-3 divider">
              Home
            </p>
          </Link>
          <Link style={{ textDecoration: "none" }} to="/about">
            <p style={{ color: "#FFF" }} className="px-3 divider">
              About Us
            </p>
          </Link>
          <Link style={{ textDecoration: "none" }} to="buystakes">
            <p style={{ color: "#FFF" }} className="px-3 divider">
              Buy Stakes
            </p>
          </Link>
          <p className="px-3">Login/Sign Up </p>
        </div>
        <div className="row justify-content-center align-items-center my-4">
          <div className="col-md-3">
            <img
              src="/assests/logo.png"
              alt="KIBI Sport"
              className=" img-fluid"
            />
          </div>
          <div className="col-md-3 px-4 py-3 thinDivider">
            <div className="d-flex gap-2 justify-content-center">
              <FaPhoneAlt color="white" size={20} />
              <p>+91 1234567890</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
              <MdEmail color="white" size={20} />
              <p className="text-decoration-underline textYellow ">
                support@kibi.co.in
              </p>
            </div>
          </div>
          <div className="col-md-3 ">
            <p>
              Shardha Launchpad, Shardha University, Knowledge Park 2, Greater
              Noida,
            </p>
            <p>Uttar Pradesh - 201310</p>
          </div>
        </div>

        <div className="d-flex justify-content-center gap-3 pt-3">
          <a href="https://www.youtube.com/c/KIBISPORTS" target="_blank">
            <FaYoutube
              className="icon"
              style={{ color: "black", fontSize: "2rem" }}
            />
          </a>
          <a href="https://www.instagram.com/kibi_sports/" target="_blank">
            <FaInstagram
              className="icon"
              style={{ color: "black", fontSize: "2rem" }}
            />
          </a>
          <a href="https://in.linkedin.com/company/kibi-sports" target="_blank">
            <FaLinkedinIn
              className="icon"
              style={{ color: "black", fontSize: "2rem" }}
            />
          </a>
          <a href="https://twitter.com/KibiSports?s=08" target="_blank">
            <AiFillTwitterCircle style={{ color: "white", fontSize: "2rem" }} />
          </a>
          <a href="https://www.facebook.com/kibisports" target="_blank">
            {" "}
            <FaFacebook style={{ color: "white", fontSize: "2rem" }} />{" "}
          </a>
        </div>
        <h4 className="d-md-flex justify-content-center mt-4">
          &copy;2021 by &nbsp;{" "}
          <span className="fw-bold textYellow">KIBI Sports</span>. All Rights
          Reserved
        </h4>
      </div>
    </div>
  );
};

export default Footer;
